import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { ErrorBoundary } from "@sentry/react";
import React from "react";
import { ErrorMsg } from "../../components/AppMessages";
import { CedarShellLayout } from "../../components/Layouts";
import { useDashboardRegistry } from "../../hooks/react-query/dashboards/useDashboardRegistry";
import { ArchivedDashboardCard } from "./components/ArchivedDashboardCard";
import "../../assets/styles/pages/archivedPage.scss";

export const ArchivedPage = () => {
  const { dashboards } = useDashboardRegistry();
  // is_active now doubles as "archived" (product decision - dashboardsApi.ts's own
  // getDashboardRegistry comment) rather than "doesn't exist" - an archived dashboard is still
  // fully viewable at its own real route (ArchivedDashboardCard's own handleOpen), just kept out
  // of the normal browse/search surfaces and surfaced here instead. Replaces the previous static
  // MENU_ELEMENTS.archived.children list with this live, backend-driven one.
  const archivedDashboards = dashboards.filter((dashboard) => !dashboard.is_active);

  return (
    <CedarShellLayout>
      <ErrorBoundary fallback={<ErrorMsg class={"formError"} />}>
        <div className="archived_page" data-test-id="archived-page">
          <div className="archived_page_header">
            <ArchiveOutlinedIcon className="page_header_icon" />
            <h1 className="archived_page_title">Archived</h1>
          </div>
          <p className="archived_page_subtitle">Dashboards that are no longer actively maintained but kept for reference.</p>

          <div className="archived_page_cards">
            {archivedDashboards.map((dashboard) => (
              <ArchivedDashboardCard dashboard={dashboard} key={dashboard.key} />
            ))}
          </div>
        </div>
      </ErrorBoundary>
    </CedarShellLayout>
  );
};
